module.exports = __webpack_public_path__ + "img/contact-header.fa364a34.png";